const initialState = () => ({
  isOpened: false,
  payload: {
    data: {},
    onSuccessCallback: null
  }
});

const ACTION_KEY = 'PAD_EDITOR_PRESCRIPTION_CONFIRMATION_MODAL';

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${ACTION_KEY}_OPEN`: {
      const { data, onSuccessCallback } = action.payload;

      return {
        ...state,
        isOpened: true,
        payload: {
          data,
          onSuccessCallback
        }
      };
    }
    case `${ACTION_KEY}_CLOSE`: {
      return initialState();
    }
    default:
      return state;
  }
};

export default reducer;
